import { FC } from 'react';

import { Upload as AntUpload, UploadProps } from 'antd';

const UploadDragger: FC<UploadProps> = (props) => {
  return <AntUpload.Dragger {...props} />;
};

export default UploadDragger;
